import { Routes, Route } from 'react-router-dom'
import { HomePage } from '../pages/HomePage'
import { LoginPage } from '../pages/LoginPage'
import { RegisterPage } from '../pages/RegisterPage'
import { ForgotPasswordPage } from '../pages/ForgotPasswordPage'
import { DashboardPage } from '../pages/DashboardPage'
import { ProfilePage } from '../pages/ProfilePage'
import { SettingsPage } from '../pages/SettingsPage'
import { SubscriptionPage } from '../pages/SubscriptionPage'
import { SubscriptionPlansPage } from '../pages/SubscriptionPlansPage'
import { WordsPage } from '../pages/WordsPage'
import { WordViewPage } from '../pages/WordViewPage'
import { DictionariesPage } from '../pages/DictionariesPage'
import { DictionaryDetailsPage } from '../pages/DictionaryDetailsPage'
import { TagsPage } from '../pages/TagsPage'
import { GroupsPage } from '../pages/GroupsPage'
import { GroupDetailsPage } from '../pages/GroupDetailsPage'
import { UsersPage } from '../pages/UsersPage'
import { UserDetailsPage } from '../pages/UserDetailsPage'
import { UserSettingsPage } from '../pages/UserSettingsPage'
import { TeacherViewPage } from '../pages/TeacherViewPage'
import { AdminUsersPage } from '../pages/admin/AdminUsersPage'
import { AdminUserViewPage } from '../pages/admin/AdminUserViewPage'
import { AdminPaymentsPage } from '../pages/admin/AdminPaymentsPage'
import { AdminTopupRequestsPage } from '../pages/admin/AdminTopupRequestsPage'
import { AdminSubscriptionsPage } from '../pages/admin/AdminSubscriptionsPage'
import { AdminSubscriptionPlansPage } from '../pages/admin/AdminSubscriptionPlansPage'
import { NotFoundPage } from '../pages/NotFoundPage'
import { CardsPage } from '../pages/CardsPage'
import { CardViewPage } from '../pages/CardViewPage'
import { LessonsIndexPage } from '../pages/LessonsIndexPage'
import { LessonDetailsPage } from '../pages/LessonDetailsPage'
import { StudentSchedulePage } from '../pages/StudentSchedulePage'
import { HomeworksPage } from '../pages/HomeworksPage'
import { UserHomeworksPage } from '../pages/UserHomeworksPage'
import { TestsPage } from '../pages/TestsPage'
import { UserTestsPage } from '../pages/UserTestsPage'
import { SelfTestCreatePage } from '../pages/SelfTestCreatePage'
import { LessonTestCreatePage } from '../pages/LessonTestCreatePage'
import { TestPage } from '../pages/TestPage'
import { ChatPage } from '../pages/ChatPage'
import { TeacherBillingPage } from '../pages/TeacherBillingPage'
import { TeacherBalancePage } from '../pages/TeacherBalancePage'
import { TtsTasksPage } from '../pages/TtsTasksPage'
import { StudentFinancePage } from '../pages/StudentFinancePage'
import { UserFinancePage } from '../pages/UserFinancePage'
import { NotificationsPage } from '../pages/NotificationsPage'
import { NotificationPreferencesPage } from '../pages/NotificationPreferencesPage'
import { ProtectedRoute } from '../components/common/ProtectedRoute'
import { TeacherRoute } from '../components/common/TeacherRoute'
import { StudentRoute } from '../components/common/StudentRoute'
import { AdminRoute } from '../components/common/AdminRoute'

export function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <ProtectedRoute>
            <NotificationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/notifications"
        element={
          <ProtectedRoute>
            <NotificationPreferencesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/settings"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <SettingsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/subscription"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <SubscriptionPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/subscription/change"
        element={
          <ProtectedRoute>
            <SubscriptionPlansPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/billing"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <TeacherBillingPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile/balance"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <TeacherBalancePage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/finance"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <StudentFinancePage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/words"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <WordsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tts-tasks"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <TtsTasksPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/words/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <WordViewPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/dictionaries"
        element={
          <ProtectedRoute>
            <DictionariesPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dictionaries/:id"
        element={
          <ProtectedRoute>
            <DictionaryDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tags"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <TagsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/groups"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <GroupsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/groups/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <GroupDetailsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UsersPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/finance"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserFinancePage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/settings"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserSettingsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserDetailsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/teacher"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <TeacherViewPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminUsersPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/users/:id"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminUserViewPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/payments"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminPaymentsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/topup-requests"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminTopupRequestsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/subscriptions"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminSubscriptionsPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin/subscription-plans"
        element={
          <ProtectedRoute>
            <AdminRoute>
              <AdminSubscriptionPlansPage />
            </AdminRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/lessons"
        element={
          <ProtectedRoute>
            <LessonsIndexPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/lessons/:id"
        element={
          <ProtectedRoute>
            <LessonDetailsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/tests"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <TestsPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/tests"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserTestsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tests/self/create"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <SelfTestCreatePage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/lessons/:lessonId/tests/create"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <LessonTestCreatePage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tests/:testId"
        element={
          <ProtectedRoute>
            <TestPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/schedule"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <StudentSchedulePage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/homeworks"
        element={
          <ProtectedRoute>
            <HomeworksPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/homeworks"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <UserHomeworksPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/cards"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <CardsPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/users/:id/cards/:cardId"
        element={
          <ProtectedRoute>
            <TeacherRoute>
              <CardViewPage />
            </TeacherRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cards"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <CardsPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/cards/:id"
        element={
          <ProtectedRoute>
            <StudentRoute>
              <CardViewPage />
            </StudentRoute>
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat"
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/rooms/:roomId"
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/direct/:userId"
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/chat/group/:groupId"
        element={
          <ProtectedRoute>
            <ChatPage />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  )
}
